<template>
  <div class="phone">
    <textInput
      class="input-field"
      :disabled="disabled"
      :label="label"
      :placeholder="placeholder"
      :prepend-inner-icon="icon"
      :prefix="prefix"
      ref="input"
      :rules="validationRules"
      :value="formattedValue"
      :width="width"
      @beforeinput="handleInput"
      @input="[setValue($event)]"
      validate-on-blur
    >
      <template
        v-if="!hideTooltip && !hideLabel && (!!tooltip || !!helpContent)"
        #append-label
      >
        <tooltip v-if="tooltip" :text="tooltip" />
        <helpIcon v-if="helpContent" :content="helpContent" />
      </template>
    </textInput>
    <template v-if="!hideTooltip && hideLabel && (!!tooltip || !!helpContent)">
      <tooltip v-if="tooltip" :text="tooltip" />
      <helpIcon v-if="helpContent" :content="helpContent" />
    </template>
  </div>
</template>

<script>
/**
 * @fileoverview Config input field for phone numbers
 *
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */

import textInput from "@/qux-common/qux22/components/molecules/input";
import getValidationRules from "@/util/getValidationRules";
import fieldMap from "./field-map.json";

export default {
  name: "PhoneField",
  components: { textInput },
  data() {
    return {
      formattedValue: this.getFormattedValue(this.value),
    };
  },
  props: {
    category: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
    helpContent: {
      type: String,
    },
    hideLabel: {
      type: Boolean,
    },
    icon: {
      type: String,
    },
    id: {
      type: String,
    },
    label: {
      type: String,
    },
    parentField: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    prefix: {
      type: String,
    },
    rules: {
      type: Array,
    },
    tooltip: {
      type: String,
    },
    value: {
      type: [Number, String],
    },
    width: {
      type: String,
    },
  },
  methods: {
    getFormattedValue(value) {
      return this.$options.filters.VMask(value, "(###) ###-####");
    },
    /**
     * Sets the value
     */
    setValue(value) {
      this.formattedValue = this.getFormattedValue(value);
      let cleanValue = value;
      const charsToRemove = ["(", ")", " ", "-"];
      for (const char of charsToRemove) {
        cleanValue = cleanValue.replace(char, "");
      }
      if (cleanValue !== value) this.$emit("setConfigValue", cleanValue);
    },
    handleInput(e) {
      // don't allow non-numeric characters
      const allowedChars = /[0-9]+/;
      if (
        (e.inputType === "insertText" || e.inputType === "insertFromPaste") &&
        !allowedChars.test(e.data)
      ) {
        e.preventDefault();
      }
    },
    getFieldValue(value) {
      return (
        fieldMap[this.category] &&
        fieldMap[this.category][this.id] &&
        fieldMap[this.category][this.id][value]
      );
    },
    validate() {
      return this.$refs.input.validate();
    },
  },
  computed: {
    validationRules() {
      return getValidationRules({
        rules: this.rules,
        inputErrorMessage: this.getFieldValue("inputErrorMessage"),
      });
    },
  },
  watch: {
    value(value) {
      this.setValue(value);
    },
  },
};
</script>

<style lang="scss" scoped>
.phone {
  display: flex;
  gap: $qvo-spacing-8;
  .input-field {
    width: 100%;
  }
}
</style>